module.exports = JSON.parse('{"Measurements":"Mediciones","Studies":"Estudios"}')